import coinPub from './coinPub'
import jypoint from './jypoint'
import luckyDraw from './luckyDraw'
import luckyDrawOurself from './luckyDrawOurself'
import facebook from './facebook'
import mission from './mission'
import coinGame from './coinGame'

const state = {
  initData: {
    coinBalance: '0',
    coinAmountRedm: '0',
    coinUid: '',
  }
}

const getters = {
}

const mutations = {
  setInitData (state, value) {
    state.initData = value
  },
}

const actions = {
  index ({ state, commit, rootState }, params) {
    return rootState.axios.get('/coin/v1frontend/coin/index', { params })
  },
  init ({ state, commit, rootState }, params) {
    return rootState.axios.get('/coin/v1frontend/coin/init', { params }).then(res => {
      if (!res.data.error) {
        commit('setInitData', res.data.model)
      }
      return res
    })
  },
  redeem ({ state, commit, rootState }, params) {
    return rootState.axios.get('/coin/v1frontend/coin/redeem', { params })
  },
  rewardSignup ({ state, commit, rootState }, params) {
    return rootState.axios.get('/coin/v1frontend/coin/reward-signup', {
      params,
      noShowError: true,
    })
  },
  searchJyorderReward ({ state, commit, rootState }, params) {
    return rootState.axios.get('/coin/v1frontend/coin/search-jyorder-reward', { params })
  },
  rewardZombie ({ state, commit, rootState }, params) {
    return rootState.axios.get('/coin/v1frontend/coin/reward-zombie', { params })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {
    coinPub,
    jypoint,
    luckyDraw,
    luckyDrawOurself,
    facebook,
    mission,
    coinGame,
  }
}
